/**
 * List Teaser List - Sorting functionality
 */

(function () {
	/**
	 * Dynamically adjust select width based on selected option
	 * @param {HTMLSelectElement} select
	 */
	function adjustSelectWidth(select) {
		// Create a temporary span to measure text width
		const tempSpan = document.createElement("span");
		tempSpan.style.visibility = "hidden";
		tempSpan.style.position = "absolute";
		tempSpan.style.whiteSpace = "nowrap";

		// Copy select's font styles to ensure accurate measurement
		const selectStyles = window.getComputedStyle(select);
		tempSpan.style.font = selectStyles.font;
		tempSpan.style.fontSize = selectStyles.fontSize;
		tempSpan.style.fontFamily = selectStyles.fontFamily;
		tempSpan.style.fontWeight = selectStyles.fontWeight;

		// Set text to currently selected option
		const selectedOption = select.options[select.selectedIndex];
		tempSpan.textContent = selectedOption.text;

		// Add to DOM to measure
		document.body.appendChild(tempSpan);
		const textWidth = tempSpan.offsetWidth;
		document.body.removeChild(tempSpan);

		// Set select width (text width + padding + icon width)
		// Icon is 16px + 2px gap = 18px on the right
		select.style.width = `${textWidth + 18}px`;
	}

	/**
	 * Initialize sorting form auto-submission
	 */
	function initSorting() {
		const sortingForms = document.querySelectorAll(
			".ListTeaserList-sortingForm",
		);

		sortingForms.forEach((form) => {
			const select = form.querySelector(".ListTeaserList-sortingSelect");

			if (!select) return;

			// Set initial width
			adjustSelectWidth(select);

			// Auto-submit form when sort option changes
			select.addEventListener("change", () => {
				form.submit();
			});
		});
	}

	// Initialize on DOM ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initSorting);
	} else {
		initSorting();
	}
})();
